import React, { useState, useEffect, useRef } from 'react';
import LeftSidebar from '../Tools/LeftSidebar';
import RightSidebar from '../Tools/Topbar';
import Pagination from '../Tools/Pagination';
import SpecialityModal from './Modals/NewCaseSubmission/Specialitiesmodal';
import AssetModal from './Modals/NewCaseSubmission/AssetModal';
import OnSubmitModal from './Modals/NewCaseSubmission/SubmitModal';
import Settings from '../Tools/Setting/Settings';
import useSettings from '../Tools/Setting/useSettings';
import axiosInstance from '../../../api';

const CaseSubmission = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalData, setModalData] = useState({
    show: false,
    success: false,
    message: ''
  });


  // Pagination Logic
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 4;

  // Settings panel
    const settingsRef = useRef();
    const {settings, updateSetting, handleColorTheme } = useSettings();

  // Function to handle case submission
  const handleSubmitCase = async (caseId) => {
    try {
      const response = await axiosInstance.get(`/case-submission/${caseId}`);

      setModalData({
        show: true,
        success: response.data.status,
        message: response.data.status 
          ? "Your case has been submitted successfully." 
          : response.data.message || "Case submission not allowed"
      });
      
    } catch (err) {
      setModalData({
        show: true,
        success: false,
        message: "Error submitting case"
      });
      console.error('Error submitting case:', err);
    }
  };


  useEffect(() => {
    const fetchCases = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get('/case-submission-listing', {          
        });
        console.log('Response',response);
        setCases(response.data.data);
        setTotal(response.data.meta?.total || response.data.data.length);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCases();
  }, [page]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const paginatedCases = cases.slice((page - 1) * limit, page * limit);

  if (loading) {
    return (
      <div id="main-wrapper">
        <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
          <RightSidebar toggleSidebar={toggleSidebar} />
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="card w-100 position-relative overflow-hidden">
                <div className="px-4 py-3">
                  <h5 className="card-title fw-semibold mb-0 lh-sm">Loading cases...</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div id="main-wrapper">
        <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
        <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
          <RightSidebar toggleSidebar={toggleSidebar} />
          <div className="body-wrapper">
            <div className="container-fluid">
              <div className="card w-100 position-relative overflow-hidden">
                <div className="px-4 py-3">
                  <h5 className="card-title fw-semibold mb-0 lh-sm">Error loading cases</h5>
                  <p className="text-danger">{error}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="main-wrapper">
      <LeftSidebar isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`page-wrapper ${isSidebarOpen ? '' : 'sidebar-closed'}`}>
        <RightSidebar toggleSidebar={toggleSidebar} />

        <div className="body-wrapper">
          <div className="container-fluid">
            <div className="card w-100 position-relative overflow-hidden">
              <div className="px-4 py-3">
                <h5 className="card-title fw-semibold mb-0 lh-sm">New Case Submissions</h5>
                <p className="card-subtitle mb-0 mt-1">Manage and submit your clinical cases</p>
              </div>

              <div className="card-body p-4">
                <div className="filter-search mt-5">
                  <h6 className="px-2 mb-0">Filter</h6>
                  <div className="filter-panel">
                    <form className="w-100">
                      <div className="form-group col-lg-4 col-md-6 col-12 p-2">
                          <input type="text" className="form-control" placeholder="Case Name"/>
                      </div>
                      <div className="form-group col-lg-4 col-md-6 col-12 p-2">
                        <select className="form-control form-select">
                          <option>Select Case type</option>
                          <option>Medical</option>
                          <option>Diagnotic</option>
                          <option>Routine</option>
                        </select>
                      </div>
                    </form> 
                  </div>
                </div>

                {/* Case Table */}
                <div className="py-3 px-0">
                  <div className="table-responsive rounded-2 ros-table">
                    <table className="table text-nowrap customize-table mb-0 align-middle">
                      <thead className="text-dark fs-4">
                        <tr>
                          <th><h6 className="fw-semibold mb-0">Case Name</h6></th>
                          <th><h6 className="fw-semibold mb-0">Case Type</h6></th>
                          <th><h6 className="fw-semibold mb-0">Specialities</h6></th>
                          <th><h6 className="fw-semibold mb-0">Assets</h6></th>
                          <th><h6 className="fw-semibold mb-0">Action</h6></th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedCases.map((caseItem) => (
                          <tr key={caseItem.id}>
                            <td><p className="mb-0 fw-normal">{caseItem.case_name}</p></td>
                            <td><p className="mb-0 fw-normal">{caseItem.case_type}</p></td>
                            <td>
                              <p className="mb-0 fw-normal">
                                <a 
                                  className="text-primary" 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#bs-show-speciality"
                                  data-case-id={caseItem.id}
                                >
                                  Show
                                </a>
                              </p>
                            </td>
                            <td>
                              <p className="mb-0 fw-normal">
                                <a 
                                  className="text-primary" 
                                  data-bs-toggle="modal" 
                                  data-bs-target="#bs-show-Assets"
                                  data-case-id={caseItem.id}
                                >
                                  Show
                                </a>
                              </p>
                            </td>
                            <td>
                              <button
                            type="button"
                            className="btn mb-1 waves-effect waves-light btn-rounded btn-outline-primary"
                            onClick={() => handleSubmitCase(caseItem.id)}
                          >
                            Submit
                          </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* Update the OnSubmitModal component */}
                <OnSubmitModal 
                  show={modalData.show}
                  success={modalData.success}
                  message={modalData.message}
                  onClose={() => setModalData({...modalData, show: false})}
                />

                {/* Pagination */}
                <Pagination
                  total={total}
                  limit={limit}
                  page={page}
                  onPageChange={handlePageChange}
                />
                <SpecialityModal/>
                <AssetModal/>
              </div>
            </div>
          </div>
        </div>
      </div> 
{/* Settings Panel */}
      <Settings 
        ref={settingsRef}
        updateSetting={updateSetting}
        handleColorTheme={handleColorTheme}
        settings={settings}  // Add this line
      />
      <div className="dark-transparent sidebartoggler" onClick={toggleSidebar}></div>
    </div>
  );
};

export default CaseSubmission;